import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, unref as _unref, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-720f19d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sdds-container" }
const _hoisted_2 = { class: "sdds-row" }
const _hoisted_3 = { class: "sdds-col-md-6" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sdds-row sdds-row-tit" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "sdds-col-md-12" }, [
    /*#__PURE__*/_createElementVNode("h3", null, "File Importer")
  ])
], -1))
const _hoisted_5 = { class: "sdds-row sdds-row-tit" }
const _hoisted_6 = { class: "sdds-col-md-4" }
const _hoisted_7 = { class: "sdds-row" }
const _hoisted_8 = {
  class: "sdds-col-md-8 sdds-file-name",
  "data-test-id": "fileName"
}
const _hoisted_9 = {
  key: 0,
  class: "sdds-row"
}
const _hoisted_10 = { class: "sdds-col-md-12" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sdds-row" }, null, -1))
const _hoisted_12 = { class: "sdds-row" }
const _hoisted_13 = { class: "sdds-col-md-4" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "sdds-col-md-4" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Upload File ")
const _hoisted_18 = {
  key: 0,
  class: "spinner fa-2x"
}
const _hoisted_19 = { class: "sdds-col-md-6" }
const _hoisted_20 = {
  key: 0,
  class: "sdds-row"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "File Preview", -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 0,
  class: "sdds-toast sdds-toast-success sdds-toast-location"
}
const _hoisted_24 = /*#__PURE__*/_createStaticVNode("<div class=\"sdds-toast-icon\" data-v-720f19d0><svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-720f19d0></svg></div><div class=\"sdds-toast-content\" data-v-720f19d0><div class=\"sdds-toast-header\" data-v-720f19d0><span class=\"sdds-toast-headline\" data-v-720f19d0>Your file has been saved successfully</span><span class=\"sdds-toast-dismiss\" data-v-720f19d0></span></div></div>", 2)
const _hoisted_26 = [
  _hoisted_24
]
const _hoisted_27 = {
  key: 1,
  class: "sdds-toast sdds-toast-error sdds-toast-location"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, null, -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { class: "sdds-toast-content" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sdds-toast-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "sdds-toast-headline" }, "Error"),
  /*#__PURE__*/_createElementVNode("span", { class: "sdds-toast-dismiss" })
], -1))
const _hoisted_32 = { class: "sdds-toast-body" }
const _hoisted_33 = {
  class: "sdds-toast-subheadline",
  "data-test-id": "mesageToast"
}

import type { Ref } from 'vue';
import { computed, reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import fileTemplate from '../helpers/options-file-template';
import schemaYNT from '../helpers/schema/rowData_ynt.json';
import schemaVal from '../helpers/validateSchema';
import lsImport from '../services/lsImportServices';
import { useMainStore } from '../store/index';

import { TypeImport } from '../types/constants';
import { FieldMap, FieldValue } from '../types/types';
import SddsDropdown from './common/BaseSddsDropdown.vue';
import FileImporterMapper from './FieldImporterMapper.vue';
import FileImporterAddData from './FileImporterAddData.vue';
import FileImporterOutput from './FileImporterOutput.vue';
import FileReader from './FileReader.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FileImporter',
  setup(__props) {

const router = useRouter();

const selectedFileType = ref(null);
const fileName = ref(null);
const selectedMarket = ref(null);

const fieldsField = ref([]);
const fieldImportData = ref([]);
const fieldsMapperTemplate: Ref<FieldMap[]> = ref([]);
const previewJsonDataRows = ref([]);

const templateStatusMapper = reactive({ valid: false, template: null });
const templateStatusAdditional = reactive({ valid: false, template: null });
const previewDataDisabled = computed(() => { return !(templateStatusMapper.valid && templateStatusAdditional.valid) });

const uploadDataDisabled = computed(() => {
  return previewJsonDataRows.value.length === 0 ||
    previewJsonDataRows.value.filter((item) => item.error).length > 0;
});
const existFileType = computed(() => selectedFileType.value !== null);
const componentKey = ref(0);
const componentKeyAdd = ref(0);
const showSucessToast = ref(false);
const showErrorToast = ref(null);
const showSaveFile = ref(false);
const keyUseDefaultFields = ref(0);
const defaultFieldsTemplate: Ref<FieldValue[]> = ref([]);

const userId = useMainStore().userId;

let base64File = null;
const fileTypeOptions = () => {
  const options = [
    {
      key: TypeImport.YNT,
      value: 'Your Next Truck',
    },
  ];
  if (useMainStore().isSuperAdmin) {
    options.push({
      key: TypeImport.YNT_MR,
      value: 'Your Next Truck - Monitoring Report',
    });
  }
  return options;
}

const reset = () => {
  // console.log('FileImporter --> reset');
  fieldsField.value = [];
  fileName.value = null;
  templateStatusMapper.valid = false;
  fieldsMapperTemplate.value.length = 0;
  fieldImportData.value.length = 0;
  previewJsonDataRows.value.length = 0;
  defaultFieldsTemplate.value.length = 0;
  keyUseDefaultFields.value = 0;

  base64File = null;
  componentKey.value += 1;
};

const getFieldsTemplate = () => {
  const result = selectedFileType.value === TypeImport.YNT ? [...fileTemplate.getYNTTemplate()]
      : [...fileTemplate.getYNTMrTemplate()];
  fieldsMapperTemplate.value.push(...result);


  const resultDefault = selectedFileType.value === TypeImport.YNT ? [...fileTemplate.getYNTDefaultFields()]
      : [...fileTemplate.getYNTMRDefaultFields()];
  defaultFieldsTemplate.value.push(...resultDefault);
}

const handleUpdateSelectionFileType = (selection) => {
  console.log('handleUpdateSelectionFileType: ', selection);
  selectedFileType.value = selection.value;
  selectedMarket.value = null;
  reset();
  templateStatusAdditional.valid = false;
  componentKeyAdd.value += 1;
};

const handleFileLoaded = (input) => {
  console.log('handleFileLoaded: ', input);
  reset();
  getFieldsTemplate();
  input.columns.forEach((value) => {
    fieldsField.value.push({ key: value, value });
  });
  fileName.value = input.name;
  base64File = input.base64;
  fieldImportData.value.push(...input.contents);
};

const handleTemplateMapper = (event) => {
  console.log('handleTemplateValidation: ', event);
  templateStatusMapper.valid = event.valid;
  templateStatusMapper.template = event.template;
  previewJsonDataRows.value.length = 0;
};

const handleTemplateAdd = (event) => {
  console.log('handleTemplateAdd: ', event);
  templateStatusAdditional.valid = event.valid;
  templateStatusAdditional.template = event.template;
  previewJsonDataRows.value.length = 0;
};

const handleMarketSelected = (event) => {
  console.log('handleMarketSelected: ', event.selectedMarket);
  selectedMarket.value = event.selectedMarket;
  reset();
  getFieldsTemplate();
};

const applyTemplate = (row, template, additionalData) => {
  const serialNumberDetails = { rowNumber: null };
  const data = {};
  const rowId = '__rowNum__';
  let error = null;

  Object.entries(template).forEach(([key, item]: any) => {
    if (item.required && !row[item.field]) {
      error += `Field ${key} is requiered, `;
    }
    if (item.type === 'number') {
      data[key] = Number(row[item.field]);
    } else if (item.type === 'boolean') {
      data[key] = String(row[item.field]?.toString()?.trim()?.toLowerCase()) === 'yes';
    } else {
      data[key] = row[item.field]?.toString()?.trim() ?? null;
    }

  });

  if (selectedFileType.value === TypeImport.YNT ||  selectedFileType.value === TypeImport.YNT_MR) {
    if (data['serialNumber'] ?? false) {
      if (data['serialNumber'].length <= 7) {
        serialNumberDetails['chassisNumber'] = Number(data['serialNumber']);
        delete data['serialNumber'];
      }
      else if (data['serialNumber'].length > 7) {
        serialNumberDetails['vinCode'] = (data['serialNumber']);
        if (data['serialNumber'].length === 17) serialNumberDetails['chassisNumber'] = Number.isNaN(Number(data['serialNumber'].slice(-7))) ? data['serialNumber'].slice(-7) : Number(data['serialNumber'].slice(-7));
        delete data['serialNumber'];
      }
    }
  }
  serialNumberDetails.rowNumber = row[rowId];
  const returnObj = { ...serialNumberDetails, ...data, ...additionalData };
  return { data: returnObj, error };
};

const previewData = () => {
  console.log('previewData');
  console.log(fieldImportData.value);
  const data = [];
  // console.log('fieldImportData.value: ', fieldImportData.value);

  let schema = null;
  if (selectedFileType.value === TypeImport.YNT || selectedFileType.value === TypeImport.YNT_MR) {
    schema = schemaYNT;
  }

  fieldImportData.value.forEach((item) => {
    const rowInfo = applyTemplate(
      item,
      templateStatusMapper.template,
      templateStatusAdditional.template,
    );

    if (schema) {
      const validInput = schemaVal.validateSchema(schema, rowInfo.data);
      rowInfo.error = !validInput.valid ? validInput.errors : null;
    }
    data.push(rowInfo);
  });
  previewJsonDataRows.value.length = 0;
  previewJsonDataRows.value.push(...data);
};

const saveFile = () => {
  console.log('saveFile');
  showSaveFile.value = true;
  showSucessToast.value = false;
  showErrorToast.value = null;
  const typeImport = selectedFileType.value;
  const request = {
    user: userId,
    fileName: fileName.value,
    typeImport,
    additionalData: templateStatusAdditional.template,
    mappingTemplate: templateStatusMapper.template,
    file: base64File,
  };

  if (!userId) {
    showErrorToast.value = "No userID found";
    showSaveFile.value = false;
    setTimeout(() => { showErrorToast.value = null }, 10000);
    return;
  }

  // console.log('request: ', request);

  lsImport.addFile(request)
    .then((response) => {
      console.log('response status: ', response.status);
      showSucessToast.value = true;
      setTimeout(() => { router.push('/history') }, 2000);
    }).catch((error) => {
      console.log('error: ', error.response ?? error);
      showErrorToast.value = error.response?.data?.message ?? 'Unknown error';
    }).finally(() => { showSaveFile.value = false; });
};

const closeErrorModal = () => {
  showErrorToast.value = null;
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(SddsDropdown, {
                "id-drop": "fileTypeDrop",
                "label-description": "Source type",
                selection: selectedFileType.value,
                options: fileTypeOptions(),
                size: "small",
                required: true,
                "onUpdate:selection": handleUpdateSelectionFileType,
                "data-test-id": "fileTypeDrop"
              }, null, 8, ["selection", "options"])
            ]),
            (_openBlock(), _createBlock(FileImporterAddData, {
              key: componentKeyAdd.value,
              "file-type": selectedFileType.value,
              "onTemplate:validation": handleTemplateAdd,
              onMarketSelected: handleMarketSelected,
              "data-test-id": "importerAddData"
            }, null, 8, ["file-type"]))
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(FileReader, {
              id: "specificationInput",
              disabled: !_unref(existFileType) || !selectedMarket.value,
              "file-type": selectedFileType.value,
              "button-label": "Load file",
              onFileLoaded: handleFileLoaded,
              "data-test-id": "specificationInput"
            }, null, 8, ["disabled", "file-type"]),
            _createElementVNode("div", _hoisted_8, _toDisplayString(fileName.value), 1)
          ]),
          (fieldsField.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("button", {
                    class: "sdds-btn sdds-btn-secondary",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (keyUseDefaultFields.value += 1)),
                    "data-test-id": "defaultTemplate"
                  }, " Import using excel template ")
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(), _createBlock(FileImporterMapper, {
            key: componentKey.value,
            "fields-template": fieldsMapperTemplate.value,
            "fields-field": fieldsField.value,
            "default-fields": defaultFieldsTemplate.value,
            "key-use-default-fields": keyUseDefaultFields.value,
            "onTemplate:validation": handleTemplateMapper,
            "data-test-id": "mapper"
          }, null, 8, ["fields-template", "fields-field", "default-fields", "key-use-default-fields"])),
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("button", {
                class: "sdds-btn sdds-btn-secondary",
                disabled: _unref(previewDataDisabled),
                onClick: previewData,
                "data-test-id": "previewData"
              }, " Preview Data ", 8, _hoisted_14)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("button", {
                class: "sdds-btn sdds-btn-primary btn-spinner",
                disabled: _unref(uploadDataDisabled),
                onClick: saveFile,
                "data-test-id": "uploadFile"
              }, [
                _hoisted_17,
                (showSaveFile.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: "spinner",
                        class: "fa-spin"
                      })
                    ]))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_16)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          (previewJsonDataRows.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22))
            : _createCommentVNode("", true),
          (_openBlock(), _createBlock(FileImporterOutput, {
            key: componentKey.value,
            "file-type": selectedFileType.value,
            "json-output": previewJsonDataRows.value
          }, null, 8, ["file-type", "json-output"]))
        ])
      ])
    ]),
    (showSucessToast.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_26))
      : _createCommentVNode("", true),
    (showErrorToast.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _createElementVNode("div", {
            class: "sdds-toast-icon",
            onClick: closeErrorModal
          }, _hoisted_29),
          _createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("span", _hoisted_33, _toDisplayString(showErrorToast.value), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})